import Component from "./PracticeList";
export default Component;
